import { CodebookModel, FileWrapper } from 'app/shared/model/shared.model';

export interface CaseAttachmentModel {
  idCaseAttachment: number;
  name: string;
  requestAttachmentType: string;
  caseAttachmentDate: Date;
  createdBy: string;
  lastDigitalSignatureBy: string;
  contentType: string;
  active: boolean;
  canSign: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface CaseAttachmentFormModel {
  idCaseAttachment: number;
  name: string;
  requestAttachment: CodebookModel[];
  createdDate: Date;
  fileWrapper: FileWrapper;
  multipartFile: File;
  active: boolean;
  canUpload: boolean;
  dataFormats: string[];
}

export const caseAttachmentInitialData = {
  idCaseAttachment: null,
  name: '',
  requestAttachment: [],
  active: true,
  createdDate: new Date(),
  fileWrapper: null,
  multipartFile: null,
  canUpload: null,
  dataFormats: [],
};

export interface CaseAttachmentPage {
  totalElements: number;
  content: CaseAttachmentModel[];
}

export interface CaseAttachmentFileRules {
  canUpload: boolean;
  dataFormats: string[];
}
